module.exports = __webpack_public_path__ + "media/images/flags/1x1/dji-8758fcdf1fd9b5be685e30d514a2ed84.svg";